import SEO from "../../../data/seo";
import HeaderTwo from "../../../layout/headers/header-two";
import BreadCrumb from "../../common/breadcrumb";
import BlogGridMain from "./blog-grid";
import FooterTwo from "../../../layout/footers/footer-two";


const BlogGrid = () => {
    return (
        <>
            <SEO pageTitle="Blog Grid" />
            <HeaderTwo />
            <BreadCrumb title="Blog Grid" innerTitle="Blog Grid" />
            <BlogGridMain />
            <FooterTwo />
        </>
    );
};

export default BlogGrid;